<template>
  <div class="tic-fixed-menus">
    <ul class="menus">
      <li class="menu">
        <a href="javascript:;" @click="ticketShow = !ticketShow">
          <img src="../../assets/images/fixed-menus/quote.png" alt="">
          业务咨询
        </a>
      </li>
    </ul>
    <TicketInset v-bind="$attrs" v-if="ticketShow" title="业务咨询">
      <i class="el-icon-close ticket-close-icon" v-if="ticketShow" @click="ticketShow = false"></i>
    </TicketInset>
  </div>
</template>

<script>
import TicketInset from "../portal/TicketInset.vue";

export default {
  name: 'TicFixedMenus',
  components: {
    TicketInset
  },
  props: {

  },
  data() {
    return {
      ticketShow: false
    }
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
.tic-fixed-menus {
  position: fixed;
  right: 15px;
  bottom: 25%;
  z-index: 999;
  .ticketInset {
    position: absolute;
    bottom: 0;
    left: -357px;
  }
  ::v-deep .ticketInset .side_line.step {
    width: 100%;

  }
  .ticket-close-icon {
    position: absolute;
    right: 20px;
    top: 23px;
    z-index: 999;
    cursor: pointer;
  }
  li {
    width: 60px;
    height: 60px;
    border-radius: 5px;
    box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.25);
    background: rgb(202, 67, 0);
    color: rgb(255, 255, 255);
    font-size: 12px;
    line-height: 16px;
  }
  a {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: rgb(255, 255, 255);
  }
  img {
    width: 23px;
    height: 21px;
    margin-bottom: 4px;
  }
}
</style>
<style>
</style>
